import Vue from 'vue';
import { DatetimeUtil } from '@/utils';

Vue.filter('dateFormat', function (model) {
  if (!model) {
    return;
  }
  return DatetimeUtil.format(new Date(model), 'yyyy-MM-dd');
});
